import React, { useState, useCallback, useEffect, useMemo } from 'react';
import Button from '@msi/cobalt-react/button';
import { Modal, ModalHeader, ModalContent, ModalActions } from '@msi/cobalt-react/modal';
import { useModalManager } from '../ModalManager/ModalManager';
import BlobService from '../../services/blobService';
import './VideoTutorialModal.css';
import { useOktaAuth } from '@okta/okta-react';

const VideoTutorialModal: React.FC = () => {
    const {authState} = useOktaAuth();
    const { currentModalId, acknowledgeModal } = useModalManager();
    const [show, setShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [videoError, setVideoError] = useState(false);
    const blobService = new BlobService();

    useEffect(() => {
        const fetchVideoUrl = async () => {
            if (authState) {
            blobService.getTutorialVideoUrl(authState)
                    .then(url => setVideoUrl(url))
                    .catch(err => {
                        console.error('Error fetching video URL:', err);
                        setVideoError(true);
                    });
            }
        };
        fetchVideoUrl();
    }, [authState]);

    useEffect(() => {
        const shouldShow = currentModalId === 'videoTutorial';
        setShow(shouldShow);
    }, [currentModalId]);

    const onClose = useCallback(() => {
        setShow(false);
        acknowledgeModal('videoTutorial');
    }, [acknowledgeModal]);

    const modalStyle = useMemo(() => ({
        overlay: { zIndex: 10000 },
        content: { zIndex: 10001 },
    }), []);

    if (!show) return null;

    return (
        <div className="video-tutorial-modal-wrapper">
            <Modal handleCloseModal={onClose} showModal={show} style={modalStyle}>
                <ModalHeader>Video Guide</ModalHeader>
                <ModalContent>
                    <div className="video-tutorial-content">
                        {videoError ? (
                            <p>Failed to load the video. Please try again later.</p>
                        ) : !videoUrl ? (
                            <p>Loading video...</p>
                        ) : (
                            <div className="video-tutorial-container">
                                <video
                                    src={videoUrl}
                                    className="video-tutorial-iframe"
                                    controls
                                    title="API Hub Tutorial Video"
                                />
                            </div>
                        )}
                    </div>
                </ModalContent>
                <ModalActions>
                    <Button text="Got it!" onClick={onClose} variant="primary" />
                </ModalActions>
            </Modal>
        </div>
    );
};

export default VideoTutorialModal;
